export default "__VITE_ASSET__slQpppK3__"